import React from "react";
import { formatScannerErrors } from "./scannerErrorComponentUtils";
import ScannerErrorComponentPresentation from "./ScannerErrorComponentPresentation";

interface ScannerPageProps {
  error: string | null;
  setError: (err: string | null) => void;
}

const ScannerErrorComponent: React.FC<ScannerPageProps> = ({
  error,
  setError,
}) => {
  if (error === null) return null;

  const formattedError = formatScannerErrors(error);
  return (
    <ScannerErrorComponentPresentation
      error={formattedError}
      onClose={() => setError(null)}
    />
  );
};

export default ScannerErrorComponent;
